import { render, staticRenderFns } from "./EmailConsultPanelItem.vue?vue&type=template&id=56dc32a1&scoped=true&"
import script from "./EmailConsultPanelItem.vue?vue&type=script&lang=js&"
export * from "./EmailConsultPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./EmailConsultPanelItem.vue?vue&type=style&index=0&id=56dc32a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dc32a1",
  null
  
)

export default component.exports